import {
	ChangeDetectionStrategy,
	Component,
	inject,
	input,
} from '@angular/core';
import { fade, openClose } from '@core/animations/animations';
import { Tenant } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ICON } from 'src/app/shared/core/util/icon';
import { DropdownOption } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { getInitials } from 'src/app/shared/core/util/string';
import { SelectedMatter } from 'src/app/shared/state/matter/matter.selectors';
import { ModalService } from 'src/app/ui/modal/modal.service';
import { TenantsModalComponent } from '../tenants-modal/tenants-modal.component';
import { dispatch, select } from '@ngxs/store';
import { RemoveTenant } from 'src/app/shared/state/matter/matter.actions';

@UntilDestroy()
@Component({
	selector: 'app-tenants-list',
	templateUrl: './tenants-list.component.html',
	animations: [fade(), openClose()],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TenantsListComponent {
	ICON = ICON;
	tenants_ = input<Tenant[]>();
	matterId_ = select(SelectedMatter.id);
	private modalService = inject(ModalService);
	private removeTenant = dispatch(RemoveTenant);
	kebabOptions: DropdownOption<string>[] = [
		{
			name: 'Edit',
			value: 'edit',
			icon: ICON.EDIT,
		},
		{
			name: 'Delete',
			value: 'delete',
			icon: ICON.DELETE,
		},
	];

	tenantInitials(tenant: Tenant): string {
		if (!tenant) return '';
		return getInitials(tenant?.fullName);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onKebabOptionSelected(option: any, tenant: Tenant): void {
		if (option?.result?.value === 'edit') {
			this.openEditModal(tenant);
			return;
		}

		if (option?.result?.value === 'delete') {
			if (!tenant || !this.matterId_()) return;
			this.removeTenant({ matterId: this.matterId_(), tenant });
		}
	}

	openEditModal(tenant: Tenant): void {
		if (!tenant) return;

		this.modalService.openModal(TenantsModalComponent, {
			title: 'Edit Tenant',
			size: 'sm',
			data: tenant,
		});
	}
}
